// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>17</span>&nbsp;&nbsp;I will give thanks to the Lord for his righteousness,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and I will make music to the name of the Lord Most High.<br> </p> </div></div>";
// Exports
module.exports = code;